/**
 * Reorder the array
 * @param {T[]} data
 * @param {number} from
 * @param {number} to
 * @return {T[]}
 */
export default function reorder<T extends any>(
    data: T[],
    from: number,
    to: number,
): T[] {
  const result = Array.from(data);

  const [removed] = result.splice(from, 1);
  result.splice(to, 0, removed);

  return result;
}
